import { render } from "./JoinNowMemberStep01.vue?vue&type=template&id=bbfdd7c6&scoped=true"
import script from "./JoinNowMemberStep01.vue?vue&type=script&lang=js"
export * from "./JoinNowMemberStep01.vue?vue&type=script&lang=js"

import "./JoinNowMemberStep01.vue?vue&type=style&index=0&id=bbfdd7c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbfdd7c6"]])

export default __exports__